<template>
  <div class="h-full">
    <div class="flex mb-20px mr-10px">
      <el-input
        size="small"
        class="mr-10px !w-50"
        placeholder="请输入请输入关键字"
        v-model="searchData.keywords"
        clearable
      ></el-input>
      <el-select
        size="small"
        class="mr-10px !w-50"
        placeholder="请选择组织级别"
        v-model="searchData.organizationLevel"
        clearable
      >
        <el-option
          v-for="item in levelList"
          :key="item.code"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
      <el-button size="small" @click="resetText()">重置</el-button>
    </div>
    <el-table
      ref="table"
      :data="baseDataList"
      border
      class="w-full"
      :height="tableHeight"
      stripe
      v-loading="baseTableLoading"
      @selection-change="handleSelection"
      :row-key="getRowKeys"
      @cell-click="cellClick"
    >
      <el-table-column
        type="selection"
        width="50"
        :reserve-selection="multiple"
        v-if="multiple"
      ></el-table-column>
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column
        label="基础排查项目"
        prop="screeningItemsName"
        width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="项目编号" prop="projectCode" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="排查内容"
        prop="screeningContent"
        width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="排查标准"
        prop="screeningCriteria"
        width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="组织级别"
        prop="organizationLevelStr"
        width="180"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="baseTableSizeChange"
      @current-change="baseTableCurrentChange"
      :current-page.sync="basePageConfig.SkipCount"
      :page-size.sync="basePageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="baseTotalCount"
      class="float-right mt-10px mb-10px ml-10px"
    ></el-pagination>
  </div>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import { HiddenDangerRectificationChecklistApi } from '@wiz-api/double-prevention-management'
import utils from '@/components/safety/enumField/utils'

const areaApi = new AreaApi()
const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()

export default {
  name: 'base-point-table',
  components: {},
  props: {
    // 是否多选
    multiple: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      areaList: [],
      levelList: [],
      // 作业活动清单
      baseDataList: [],
      baseTableLoading: false,
      baseTotalCount: 0,
      searchData: {},
      basePageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionData: [],
    }
  },
  watch: {
    selectionData(list) {
      this.$emit('sumCount', {
        key: 'baseCount',
        value: list.length,
      })
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    selectIds() {
      return this.id ? this.id.split(',') : []
    },
    selectNames() {
      return this.name ? this.name.split(',') : []
    },
  },
  created() {
    utils.getDataCategory(
      ['DoublePreventionManagement.DataCategory.ControlHierarchy'],
      ['levelList'],
      this
    )
    this.getBaseList()
    // this.getConfig()
    // 获取区域列表
    this.getAreaList()
  },
  mounted() {
    if (this.multiple) {
      this.setSelect()
    }
  },
  methods: {
    setSelect() {
      if (this.selectIds.length === this.selectNames.length) {
        this.selectIds.forEach((id, index) => {
          this.$refs.table.toggleRowSelection({ id, baseName: this.selectNames[index] })
        })
      }
    },
    getRowKeys(row) {
      return row.id
    },
    cellClick(row) {
      if (!this.multiple) {
        this.selectionData = [row]
        this.$emit('handleOk')
      }
    },
    // 选中结果事件
    handleSelection(values) {
      if (this.multiple) {
        this.selectionData = values
      }
    },
    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 搜索 equip 设备设施 base 作业活动
    handleSearch() {
      this.basePageConfig.SkipCount = 1
      this.getBaseList()
    },
    // 页码改变
    baseTableSizeChange(MaxResultCount) {
      this.basePageConfig.MaxResultCount = MaxResultCount
      this.getBaseList()
    },
    // 页数改变
    baseTableCurrentChange(SkipCount) {
      this.basePageConfig.SkipCount = SkipCount
      this.getBaseList()
    },
    // 作业活动列表
    async getBaseList() {
      const data = {
        maxResultCount: this.basePageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.basePageConfig.SkipCount - 1) * this.basePageConfig.MaxResultCount, // 跳过多少条
        ...this.searchData,
      }
      this.baseTableLoading = true
      const [
        err,
        res,
      ] = await hiddenDangerRectificationChecklistApi.basicManagementRiskPointPagedListQuery(data)
      if (!err) {
        this.baseDataList = res.items.map((item) => {
          item.id = item.riskPointId
          return item
        })
        this.baseTotalCount = res.totalCount
      }
      this.baseTableLoading = false
    },
  },
}
</script>

<style></style>
